import { CommonLayout, CommonLayoutForInvestor } from '../commonComponents';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import UpdateNominee from '.';
import { addEditNominee } from './addEditNominee';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { USER_ROLES } from '../../utils/constant';
import VerifyAddNomineeOtp from './VerifyAddNomineeOtp';


const routerList = [
    {
        name: 'Add Update Nominee',
        path: "updateNominee",
        component: UpdateNominee,
    },
    {
        name: 'Edit Nominee',
        path: "edit-nominee",
        component: addEditNominee,
    },
    {
        name: 'Send to BSE OTP',
        path: "otp-screen",
        component: VerifyAddNomineeOtp,
    }
]

function NomineeRoutes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            {
                routerList.map((item, index) => <Route
                    exact
                    key={index}
                    path={`${path}/${item.path}`}
                    component={item.component}
                />)
            }
        </Switch>
    );
}

const NomineeLayout = ({ children }: any) => {
    const { role = '' } = useSelector((state: RootStateType) => state.auth);
    return role === USER_ROLES.INVESTOR ? (
        <CommonLayoutForInvestor>
            {children}
        </CommonLayoutForInvestor>
    ) : (
        <CommonLayout>
            {children}
        </CommonLayout>
    )
}
export default function NomineeRouter(): JSX.Element {
    return (
        <>

            <NomineeLayout>
                <NomineeRoutes />
            </NomineeLayout>
        </>
    )
}